import { Component, OnInit, ViewChild, Input, SimpleChanges, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { GestockService } from '../services/gestock.service';
import { MatSort } from '@angular/material/sort';


@Component({
  selector: 'app-statstock',
  templateUrl: './statstock.component.html',
  styleUrls: ['./statstock.component.css']
})
export class StatstockComponent implements OnInit {


  @Input() selectedBoutique: any;

  displayedColumns: string[] = [
    'categorie', 'nomarticle', 
    'valeurstock', 
    'periodefortedemande', 'periodefaibledemande', 
    'niveaustock', 'option'
  ];

  // Fenêtre de stats d'un article
  @ViewChild('statArticleDialog') statArticleDialog: TemplateRef<any>;
  articleSelectionne: any = null;
  statsArticle: any = null;
  chargementStatsArticle = false;
  erreurStatsArticle = '';
  afficherTableVentes = false;
  moisCourts = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'];

  dataSource : MatTableDataSource<any> ;
  categories: string[] = [];
  newCategory: string = '';
  samacaabiyoonwii: string = '';
  retourClientWS: any;
  valeurStockTotale: number = 0;
  nbStockDormant: number = 0;

  valeurTotaleStock : any ; 
  moyenneRotation : any ;
  totalDormants : any ;
  tauxDisponibiliteMoyen : any ;



  donnees : any ;

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;


  constructor(private configServer: GestockService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
  }


  ngAfterViewInit(): void {
    this.getAllStatStock();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Changes : ", changes) ;
    if (changes['selectedBoutique']) {
      console.log('Nouvelle valeur :', changes['selectedBoutique'].currentValue);
      this.selectedBoutique = changes['selectedBoutique'].currentValue ;
      if(changes['selectedBoutique'].firstChange==false){
        console.log("Here we are !") ;
        this.getAllStatStock();
      }
    }
  }

  getAllStatStock(): void {
    this.configServer.getStatStockBoutique(this.samacaabiyoonwii, this.selectedBoutique).then((retour) => {
      this.retourClientWS = retour;

      if (retour.statutreq === 1) {
        let data = retour.data;
        this.donnees = data ;
        this.dataSource = new MatTableDataSource(data) ;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.updateAggregats(data);
      } else {
        console.error('Échec récupération stats');
      }
    });
  }

  getAllCategories(): void {
    this.configServer.getAllCategories(this.samacaabiyoonwii).then((retour) => {
      if (retour.statutreq === 1) {
        this.categories = retour.data;
      }
    });
  }


  getMontantFormatee(montant){
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd ;
  }

  moisNoms = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
              'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

  /**
   * Convertit une période de demande en nom de mois :
   * "3" / "03" -> "Mars", "2025-03" -> "Mars 2025". Toute autre valeur est affichée telle quelle.
   */
  getNomMois(periode){
    if (periode === null || periode === undefined || periode === '')
      return '-' ;

    const valeur = String(periode).trim() ;

    let match = valeur.match(/^(\d{1,2})$/) ;
    if (match) {
      const mois = Number(match[1]) ;
      return (mois >= 1 && mois <= 12) ? this.moisNoms[mois - 1] : valeur ;
    }

    match = valeur.match(/^(\d{4})-(\d{1,2})/) ;
    if (match) {
      const mois = Number(match[2]) ;
      return (mois >= 1 && mois <= 12) ? this.moisNoms[mois - 1] + ' ' + match[1] : valeur ;
    }

    return valeur ;
  }



  /** Ouvre la fenêtre de stats détaillées de l'article de la ligne */
  ouvrirStatsArticle(element): void {
    this.articleSelectionne = element;
    this.statsArticle = null;
    this.erreurStatsArticle = '';
    this.afficherTableVentes = false;
    this.chargementStatsArticle = true;

    this.dialog.open(this.statArticleDialog, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false
    });

    this.configServer.getStatArticle(this.samacaabiyoonwii, element.articleid, element.boutique_id).then((retour) => {
      this.chargementStatsArticle = false;
      if (retour && retour.statutreq === 1) {
        this.statsArticle = retour.data;
      } else {
        this.erreurStatsArticle = (retour && retour.message) ? retour.message : 'Impossible de charger les statistiques';
      }
    });
  }

  /** "2025-03" -> "Mar" ; l'année est ajoutée pour janvier pour repérer le changement d'année */
  libelleMoisCourt(mois: string): string {
    const [annee, m] = mois.split('-').map(Number);
    const nom = this.moisCourts[m - 1];
    return m === 1 ? nom + ' ' + String(annee).slice(2) : nom;
  }

  libelleMoisLong(mois: string): string {
    const [annee, m] = mois.split('-').map(Number);
    return this.moisNoms[m - 1] + ' ' + annee;
  }

  get maxQteMensuelle(): number {
    if (!this.statsArticle) return 0;
    return Math.max(0, ...this.statsArticle.ventesMensuelles.map(v => v.qte));
  }

  /** Hauteur de la barre en % de la zone de tracé */
  hauteurBarre(qte: number): number {
    const max = this.maxQteMensuelle;
    return max > 0 ? Math.max(0, qte) / max * 100 : 0;
  }

  /** Index du mois le plus vendu (seule barre étiquetée directement) */
  get indexMoisMax(): number {
    if (!this.statsArticle || this.maxQteMensuelle <= 0) return -1;
    return this.statsArticle.ventesMensuelles.findIndex(v => v.qte === this.maxQteMensuelle);
  }

  get niveauTotalArticle(): number {
    if (!this.statsArticle) return 0;
    return this.statsArticle.stockParDepot.reduce((s, d) => s + d.qte, 0);
  }

  get valeurTotaleArticle(): number {
    if (!this.statsArticle) return 0;
    return this.statsArticle.stockParDepot.reduce((s, d) => s + d.valeur, 0);
  }

  get tauxMargeArticle(): number {
    if (!this.statsArticle || !this.statsArticle.totaux.ca) return null;
    return this.statsArticle.totaux.marge / this.statsArticle.totaux.ca * 100;
  }

  /** Nombre de jours de stock au rythme des ventes des 90 derniers jours */
  get couvertureStockJours(): number {
    if (!this.statsArticle) return null;
    const venteParJour = this.statsArticle.totaux.qte_90j / 90;
    if (venteParJour <= 0) return null;
    return Math.max(0, this.niveauTotalArticle) / venteParJour;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  filterByCategory(): void {
    if (this.newCategory === '') {
      this.getAllStatStock();
      return;
    }

    const filtered = this.dataSource.data.filter((item: any) =>
      item.categorie.toLowerCase() === this.newCategory.toLowerCase()
    );
    this.dataSource.data = filtered;
    this.updateAggregats(filtered);
  }

  updateAggregats(data: any[]): void {

    let valeurTotaleStock = 0;
    let totalRotation = 0;
    let totalDormants = 0;
    let totalTauxDisponibilite = 0;

    const totalArticles = data.length;

    data.forEach(item => {
      valeurTotaleStock += +item.valeurstock;
      totalRotation += +item.rotation;
      totalDormants += +item.stockdormant;
      totalTauxDisponibilite += +item.tauxdisponibilite;
    });

    const moyenneRotation = totalArticles > 0 ? totalRotation / totalArticles : 0;
    const tauxDisponibiliteMoyen = totalArticles > 0 ? totalTauxDisponibilite / totalArticles : 0;

    this.valeurTotaleStock =  Number(valeurTotaleStock); 
    this.moyenneRotation = Number(moyenneRotation.toFixed(4)) ;
    this.totalDormants = totalDormants ;
    this.tauxDisponibiliteMoyen =  Number(tauxDisponibiliteMoyen.toFixed(2)) ;

    console.log(valeurTotaleStock, moyenneRotation, totalDormants, tauxDisponibiliteMoyen) ;
   
  }

  calculerAgrégatsStock(data: any[]){

  }

  exportToExcel(): void {
    // Ajoute ici l'exportation via XLSX ou autre lib
    console.log('Fonction d’export Excel appelée');
  }

}
